<div class="dialog-class" [ngClass]="{ 'flag-comments-dialog': data?.headerText === 'Flag Comments' }">
  <div class="info-logo">
    <div class="logo" *ngIf="!data?.hideIcon">
      <img src="assets/images/alert.svg" alt="" />
    </div>
    <div class="info">
      <h3>{{ data?.headerText }}</h3>
      <p *ngIf="!data?.allowHtml">{{ data?.messageText }}</p>
      <div class="content-container overflow-y-auto" *ngIf="data?.allowHtml" [innerHTML]="safeMessageText | safe"></div>
    </div>
  </div>
  <div class="buttons">
    <button [ngClass]="data?.cancelButtonClass ? data?.cancelButtonClass : 'cancel'" (click)="dialogRef.close()">{{ data?.cancelButtonText }}</button>
    @if(data?.confirmButtonText) {
      <button [class]="data.confirmButtonClass" (click)="proceed('confirm')">{{ data?.confirmButtonText }}</button>
    }
    <button *ngIf="data?.confirmTwoButtonText" [class]="data.ConfirmButtonTwoClass" class="darker-red" (click)="proceed('confirmTwo')">{{ data?.confirmTwoButtonText }}</button>
  </div>
</div>
